<template>
  <v-dialog v-model="dialogExport" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title> Xuất kho  {{currentTime | display_date('DD-MM-YYYY')}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3 pt-8>
          <v-flex lg12 md12 sm12>
            <v-checkbox label="Tạo đơn ký gửi" v-model="isCreateDeposit" :disabled="createDepositDisabled" checked></v-checkbox>
          </v-flex>
          <v-flex lg7 md7 sm7>
            <v-layout row wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-autocomplete label="Chọn khách hàng" v-model="selectedUID" :items="customers" item-text="Username" item-value="ID"></v-autocomplete>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 ma-0>
                    <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader" :disabled="selectedUID == 0"></v-checkbox>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0>
                    <v-text-field
                    label="Mã vận đơn"
                    ref="trancode"
                    v-model="currentTransaction.TransactionCode"
                    class="input-group--focused"
                    @input="codeChanged"
                    @keyup.enter="manualChanged"
                    :disabled="selectedUID == 0"
                    ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0>
                    <v-data-table
                    :headers="headers"
                    :items="Packages"
                    :must-sort="true"
                    :mobile-breakpoint="100"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:item="{ item, index }">
                        <tr>
                        <td>{{ item.TransactionCode }}</td>
                        <td class="text-center">
                            <v-icon small @click="deleteTransaction(index)">fa-trash-alt</v-icon>
                        </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg5 md5 sm5 pl-3 pr-2 pt-3>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap pl-5>
                <v-flex lg6 md6 sm12 pr-2>
                  <h-currency-input
                    label="Số lượng"
                    v-model="Packages.length"
                    :decimal="0"
                    readonly
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 pr-2 v-if="isCreateDeposit">
                  <h-currency-input
                    label="Phí ship nội địa"
                    v-model="chinaFeeShip"
                    :decimal="1"
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 pr-2 v-if="isCreateDeposit">
                  <v-select v-model="feeShipType" label="Quy cách" :items="weightTypes" item-text="name" item-value="value"></v-select>
                </v-flex>
                <v-flex lg6 md6 sm12 pr-2 v-if="isCreateDeposit">
                  <h-currency-input
                    :label="feeShipType == 0 ? 'Tổng cân' : 'Tổng khối'"
                    v-model="totalWeight"
                    :decimal="1"
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 pr-2 v-if="isCreateDeposit">
                  <h-currency-input
                    label="Phí khác"
                    v-model="otherFee"
                    :decimal="0"
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 pr-2 v-if="isCreateDeposit">
                  <v-text-field
                    label="Ghi chú"
                    v-model="otherFeeNote"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 pt-3 pr-2>
                  <v-text-field
                    label="Địa chỉ nhận"
                    v-model="Address"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12 pr-2 v-if="isCreateDeposit">
                  <h-currency-input
                    label="Tổng tiền đơn hàng"
                    v-model="totalPayLeft"
                    :decimal="0"
                    disabled
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 pr-2 v-if="isCreateDeposit">
                  <h-currency-input
                    label="Dư ví"
                    v-model="currentCustomer.Wallet"
                    :decimal="0"
                    disabled
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 pr-2 v-if="isCreateDeposit">
                  <h-currency-input
                    label="Còn thiếu"
                    :value="totalPayLeft > currentCustomer.Wallet ? totalPayLeft - currentCustomer.Wallet : 0"
                    :decimal="0"
                    disabled
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 pr-2 v-if="isCreateDeposit">
                  <h-currency-input
                    label="Tiền mặt (khách nạp)"
                    v-model="inputCash"
                    :decimal="0"
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
              </v-layout>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray darken-1" @click="createDeposit" :disabled="depositID>0" v-if="isCreateDeposit">Tạo đơn</v-btn>
              <v-btn color="gray darken-1" @click="payDeposit" :disabled="!depositID || paid" v-if="isCreateDeposit">Thanh toán</v-btn>
              <v-btn color="red darken-1 white--text" @click="saveItem" :disabled="(isCreateDeposit && !paid) || exported">Xuất kho</v-btn>
              <v-btn color="gray darken-1" @click="printItem" :disabled="!exported">In ấn</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import configs from "@/configs";
import Vue from 'vue';
import _ from "lodash";
import { mapState } from "vuex";
import { getCurrentTime, sendErrorNotice, playSound } from "@/commons/utils";
import { request_list, print_export_receipt_order } from '@/commons/hpod';
export default {
  name: "export_popup",
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 5;
    return {
      selectedUID: 0,
      valid: true,
      useBarcodeReader: false,
      autoPackageCode: configs.SYSTEM_CONFIG.auto_pack_code,
      weightTypes: configs.WEIGHT_TYPES,
      currentTransaction: {
        TransactionCode: ""
      },
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      packcodeRules: [v => (!this.autoPackageCode && !!v) || "Mã bao không được để trống."],
      currentTime: getCurrentTime(),
      currentCustomer: {},
      Packages: [],
      CustomerName: '',
      Address: '',
      PhoneNumber: '',
      isCreateDeposit: false,
      chinaFeeShip: 0,
      feeShipType: 0,
      totalWeight: 0,
      inputCash: 0,
      otherFee: 0,
      otherFeeNote: '',
      depositID: 0,
      totalPayLeft: 0,
      paid: false,
      exported: false,
      createDepositDisabled: false,
    };
  },
  props: ["dialogExport"],
  watch: {
    useBarcodeReader() {
      if (this.useBarcodeReader) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    dialogExport() {
        if(this.dialogExport) {
            this.Packages = [];
            this.selectedUID = 0;
            this.Address = '';
            this.CustomerName = '';
            this.PhoneNumber = '';
            this.isCreateDeposit = false;
            this.chinaFeeShip = 0;
            this.feeShipType = 0;
            this.totalWeight = 0;
            this.inputCash = 0;
            this.otherFee = 0;
            this.otherFeeNote = '';
            this.depositID = 0;
            this.paid = false;
            this.totalPayLeft = 0;
            this.exported = false;
            this.createDepositDisabled = false;
            this.currentCustomer = {};
        }
    },
    selectedUID() {
      this.currentCustomer = _.find(this.customers, {'ID': this.selectedUID}) || {};
      if(this.currentCustomer) {
        this.Address = `${this.currentCustomer.Username} - ${this.currentCustomer.PhoneNumber} - ${this.currentCustomer.Address}`;
      }
    }
  },
  computed: {
    ...mapState({
        customers: state => state.customer.master.data,
    })
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    deleteTransaction(index) {
      this.Packages.splice(index, 1);
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    printItem() {
      const frame_printing = print_export_receipt_order({'CustomerName': this.CustomerName, 'PhoneNumber': this.PhoneNumber, 'Address': this.Address, 'TotalWeight': this.totalWeight, 'FeeShipType': this.feeShipType}, this.Packages, true);
      var doc = document.getElementById('print_frame').contentWindow.document;
      doc.open();
      doc.write(frame_printing);
      doc.close();
      setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
    },
    saveItem() {
      this.$store.dispatch("orderTransaction/updateMultiple", {param: {
        TransactionIDs: _.map(this.Packages, "ID"),
        Status: 5
      }, message: 'Xuất kho thành công.'}).then((data) => {
        if(data && data.status == 'success') {
          this.exported = true;
        }
      });
    },
    createDeposit() {
      let newOrder = {};
      if(this.Packages.length == 0) {
          sendErrorNotice("Hãy nhập danh sách mã vận đơn!");
          return;
      }
      if(!this.selectedUID) {
          sendErrorNotice("Hãy chọn khách hàng!");
          return;
      }
      
      if(!this.totalWeight) {
          sendErrorNotice("Hãy nhập tổng cân nặng!");
          return;
      }
      this.currentCustomer = _.find(this.customers, {'ID': this.selectedUID}) || {};
      newOrder.UID = this.selectedUID;
      newOrder.Username = this.currentCustomer.Username;
      newOrder.ReceivePlaceID = this.currentCustomer.ReceivePlaceID;
      newOrder.ChinaStoreID = this.currentCustomer.ChinaStoreID;
      newOrder.TransactionCodes = this.Packages;
      newOrder.OrderWeight = this.totalWeight;
      newOrder.FeeShipCN = this.chinaFeeShip;
      newOrder.FeeOther = this.otherFee;
      newOrder.FeeOtherNote = this.otherFeeNote;
      newOrder.ManualEditWeight = 1;
      newOrder.Status = 16;

      this.$store.dispatch("deposit/setDetail", {'data': newOrder}).then((ret) => {
        ret = ret.data ? ret.data : ret;
        if(!_.isEmpty(ret) && ret.ID) {
          this.depositID = ret.ID;
          this.totalPayLeft = ret.TotalPriceVND;
          for (let i = 0; i < this.Packages.length; i++) {
            this.Packages[i].OrderID = this.depositID;
          }
        }
      });
    },
    payDeposit() {
      if(this.depositID > 0) {
        this.$store.dispatch("payOrder/updatePayOrder", {
          order_ids: [],
          deposit_ids: [this.depositID],
          cash: this.inputCash,
          method: 90,
          shipFee: 0,
          feeOther: 0,
          feeOtherName: '',
          customer_id: this.selectedUID,
          shippingMethod: '',
          totalPayLeft: this.totalPayLeft
        }).then((ret) => {
          if(ret.status == 200) {
            this.paid = true;
          }
        });
      }
      else {
        sendErrorNotice("Chưa tạo đơn hàng!");
      }
    },
    manualChanged() {
      this.$refs.form.validate();
      if (this.currentTransaction.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      this.$refs.form.validate();
      if (this.currentTransaction.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      function() {
         var param = {
            filter: [{
                column: "TransactionCode",
                value: this.currentTransaction.TransactionCode,
                condition: "s_equal"
            }]
        };
        if(!this.isCreateDeposit) {
          param.filter.push({
            column: "Status",
            value: configs.PACKAGE_STATUS_ENUM.DA_VE_VN,
            condition: "equal"
          });
        }
        
        const checkTran = _.find(this.Packages, {TransactionCode: this.currentTransaction.TransactionCode})
        if(checkTran) {
          this.currentTransaction = {
            TransactionCode: ""
          };
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Mã vận đơn đã tồn tại phiếu.')
          return;
        }
        request_list('order_transactions', ret => {
          if(ret.data.length > 0) {
            if(!ret.data[0].Deliverable && !this.isCreateDeposit) {
                sendErrorNotice('Đơn hàng chưa tất toán.');
                playSound('chua-tat-toan-voice.mp3');
                return;
            }
            if(!this.isCreateDeposit && ret.data[0].UID != this.selectedUID) {
                sendErrorNotice('Mã vận đơn không phải của khách hàng đã chọn.');
                playSound('khong-co-voice.mp3')
                return;
            }
            if(this.isCreateDeposit && ret.data[0].OrderID > 0) {
                sendErrorNotice('Mã vận đơn đã có trong đơn hàng khác.');
                return;
            }
            if(this.isCreateDeposit && ret.data[0].Status == configs.PACKAGE_STATUS_ENUM.KH_DA_NHAN) {
                sendErrorNotice('Mã vận đơn đã xuất kho.');
                return;
            }
            this.Packages.unshift(ret.data[0]);
            if(ret.data[0].ShippingInfo) {
              this.Address = ret.data[0].ShippingInfo;
            }
            this.currentTransaction = {
              TransactionCode: ""
            };
            this.exported = false;
            this.createDepositDisabled = true;
            this.$nextTick(() => this.$refs.trancode.focus());
            playSound('co-voice.mp3');
          }
          else if (this.isCreateDeposit) {
            this.$store.dispatch("orderTransaction/setDetail", {
              data: {
                TransactionCode: this.currentTransaction.TransactionCode,
                Status: configs.PACKAGE_STATUS_ENUM.DA_VE_VN
              }
            }).then((data) => {
              if(data) {
                if(data.ID > 0) {
                  this.Packages.unshift(data);
                }
                else {
                  this.Packages = this.Packages.concat(data);
                }
                this.currentTransaction = {
                  TransactionCode: ""
                };
                this.exported = false;
                this.createDepositDisabled = true;
                this.$nextTick(() => this.$refs.trancode.focus());
              }
            });
          }
          else {
            sendErrorNotice('Mã vận đơn chưa nhập kho.')
            playSound('khong-co-voice.mp3')
          }              
        }, Vue.http, param, this.$store.state.authentication.token);
      },
      100,
      {
        leading: false,
        trailing: true
      }
    )
  }
};
</script>
